/* Publish by EComposer at 2026-11-03 17:06:44*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pw9w5vzilj"]=  window.__ectimmers["ecom-pw9w5vzilj"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-pw9w5vzilj').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-pw9w5vzilj', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-pw9w5vzilj', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-18gbeuirmre').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-18gbeuirmre', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-18gbeuirmre', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-c5upndzwwd').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-c5upndzwwd', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-c5upndzwwd', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-6e2hlwfizo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6e2hlwfizo', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6e2hlwfizo', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-131o6oqs6h2r').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-131o6oqs6h2r', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-131o6oqs6h2r', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-6z7uwwozfdk').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6z7uwwozfdk', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6z7uwwozfdk', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-7ogjo9e97vv').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-7ogjo9e97vv', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-7ogjo9e97vv', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-uxdk0b4a65n').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-uxdk0b4a65n', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-uxdk0b4a65n', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-madbqqgqy7g').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-madbqqgqy7g', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-madbqqgqy7g', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ha7njjovdje').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ha7njjovdje', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ha7njjovdje', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-h2v4pa8vu7p').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-h2v4pa8vu7p', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-h2v4pa8vu7p', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-0aemg8ac2dn').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-0aemg8ac2dn', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-0aemg8ac2dn', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-8ydhmczhmqq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-8ydhmczhmqq', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-8ydhmczhmqq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-vkohatcop2').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-vkohatcop2', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-vkohatcop2', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-v0903slfqei').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-v0903slfqei', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-v0903slfqei', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-1rvgy7ep1wy').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-1rvgy7ep1wy', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-1rvgy7ep1wy', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-vqyn2tpgo8r').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-vqyn2tpgo8r', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-vqyn2tpgo8r', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-4g0apkzoln4').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-4g0apkzoln4', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-4g0apkzoln4', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-rqcpvtjvx2').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-rqcpvtjvx2', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-rqcpvtjvx2', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ibuxrc9a52f').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ibuxrc9a52f', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ibuxrc9a52f', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-6he2qg1ohdp').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6he2qg1ohdp', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6he2qg1ohdp', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-zbunbu3pyyb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-zbunbu3pyyb', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-zbunbu3pyyb', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-dkm5dl9ahh8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-dkm5dl9ahh8', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-dkm5dl9ahh8', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-f9n3xk9qe4').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-f9n3xk9qe4', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-f9n3xk9qe4', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-g6s5467greh').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-g6s5467greh', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-g6s5467greh', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-trs8qqml45').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-trs8qqml45', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-trs8qqml45', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-i9f7wgtaqs').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-i9f7wgtaqs', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-i9f7wgtaqs', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-6gn6flqedhn').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6gn6flqedhn', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6gn6flqedhn', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-hka0y48687f').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-hka0y48687f', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-hka0y48687f', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-8kqaxyeuw2').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-8kqaxyeuw2', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-8kqaxyeuw2', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3acmsmysu4v').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3acmsmysu4v', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3acmsmysu4v', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-kh0p2mh9mhs').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-kh0p2mh9mhs', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-kh0p2mh9mhs', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-8qajjmdia6h').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-8qajjmdia6h', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-8qajjmdia6h', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-vnmjem6svye').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-vnmjem6svye', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-vnmjem6svye', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3j5cxu7kbzo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3j5cxu7kbzo', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3j5cxu7kbzo', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-41wm8t8km36').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-41wm8t8km36', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-41wm8t8km36', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-lnvk0us1efm').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-lnvk0us1efm', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-lnvk0us1efm', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-f9t6zl54pl').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-f9t6zl54pl', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-f9t6zl54pl', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-f6tbitbpyqa').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-f6tbitbpyqa', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-f6tbitbpyqa', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-1pycbijnvs5').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-1pycbijnvs5', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-1pycbijnvs5', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ug0615wfn7').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ug0615wfn7', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ug0615wfn7', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qjy7byuu7e').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qjy7byuu7e', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qjy7byuu7e', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-yzxx9y0m0i').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-yzxx9y0m0i', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-yzxx9y0m0i', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5aj99zezypb"]=  window.__ectimmers["ecom-5aj99zezypb"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const n=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},o=function(){e.removeEventListener("mousemove",n),e.removeEventListener("mouseup",o),e.style.cursor="default",e.style.removeProperty("user-select")},s=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",n),e.addEventListener("mouseup",o)};e.addEventListener("mousedown",s),e.addEventListener("mouseleave",o)}

                    });
                    
                        document.querySelectorAll('.ecom-5aj99zezypb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-5aj99zezypb', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-5aj99zezypb', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ynqm7fbvv7').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ynqm7fbvv7', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ynqm7fbvv7', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-39hu03874lo"]=  window.__ectimmers["ecom-39hu03874lo"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-39hu03874lo"]["pl5g4avfo"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-39hu03874lo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-39hu03874lo', settings: {"link":"none","lightbox":"no"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-39hu03874lo', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-4vo610225uk').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-4vo610225uk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-4vo610225uk', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-dlk2jemjrct').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-dlk2jemjrct', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-dlk2jemjrct', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-vuu2nlssr6').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-vuu2nlssr6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-vuu2nlssr6', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-g9hhsnpyp1i').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-g9hhsnpyp1i', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-g9hhsnpyp1i', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-jts7wjs9v8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-jts7wjs9v8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-jts7wjs9v8', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-emqmk9wog9g').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-emqmk9wog9g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-emqmk9wog9g', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0r57txsh6j5l"]=  window.__ectimmers["ecom-0r57txsh6j5l"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-0r57txsh6j5l"]["bfnl41su4"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-0r57txsh6j5l').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-0r57txsh6j5l', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-0r57txsh6j5l', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ow25n1xufki"]=  window.__ectimmers["ecom-ow25n1xufki"] || {};
var $,E,I,j,M,D;let t=this.$el;if(!t)return;let e=this.isLive;const i=($=this.settings.disable_auto_close)!=null?$:!1,n=(E=this.settings.disable_auto_close__tablet)!=null?E:!1,o=(I=this.settings.disable_auto_close__mobile)!=null?I:!1,s=(j=this.settings.scroll_on_mobile)!=null?j:!1,r=(M=this.settings.disable_effect)!=null?M:!1,a=(D=this.settings.close_all)!=null?D:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(T=>T.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function p(T){const F=T.getBoundingClientRect();return F.top>=0&&F.left>=0&&F.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&F.right<=(window.innerWidth||document.documentElement.clientWidth)}function m(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(T){return o&&T<768||n&&T>767&&T<1025||i&&T>1024}function b(T){if(!T)return;const F=T.style.transition;T.style.transition="none",T.style.height="auto";const H=T.scrollHeight;T.style.height="0px",T.offsetHeight,T.style.transition=F,requestAnimationFrame(()=>{const R=r?"auto":e?H+"px":"auto";T.style.height=R})}function y(T){T.classList.remove("ecom-item-active");const F=T.querySelector(":scope > .ecom-accordion__body");F&&(r||(F.style.height=F.scrollHeight+"px",F.offsetHeight),requestAnimationFrame(()=>{F.style.height="0px"}))}function v(T){let F=0;if(T.offsetParent)do F+=T.offsetTop;while(T=T.offsetParent);return F}function w(T){const F=Math.max(0,T),H=window.pageYOffset||document.documentElement.scrollTop,R=F-H;if(R===0)return;const K=300;let W=null;function G(se){W||(W=se);const te=Math.min((se-W)/K,1),Y=te<.5?2*te*te:1-Math.pow(-2*te+2,2)/2;window.scrollTo(0,H+R*Y),te<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function S(T){w(v(T)-100)}function C(T,F=!1){T.forEach((H,R)=>{const K=H.parentNode,W=K.querySelector(":scope > .ecom-accordion__body");!r&&W&&W.classList.add("ecom-effect-accodion");const G=K.classList.contains("ecom-item-active");W&&!a&&(F&&R===0||G)&&requestAnimationFrame(()=>{W.style.height=W.scrollHeight+"px"}),H.onclick=function(se){var ue,_e;if(se.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const te=m(),Y=this.parentNode,pe=Y.parentNode,de=pe.querySelectorAll(":scope > .ecom-accordion__item"),he=Array.from(de).map(we=>we.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),J=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const V=this.classList.contains("ecom-item-active"),X=_(te);if(V)X?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(de.forEach(y),he.forEach(we=>we.classList.remove("ecom-item-active")));else{X||(de.forEach(y),he.forEach(Ae=>Ae.classList.remove("ecom-item-active"))),H.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let we=Y.closest(".ecom-accordion__body");for(;we;)we.style.height="auto",we=(_e=(ue=we.parentElement)==null?void 0:ue.closest)==null?void 0:_e.call(ue,".ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion"),b(J)}window.dispatchEvent(new window.Event("renderScroll"));const Q=this,ge=s||te>1024;function ee(){window.dispatchEvent(new window.Event("renderScroll")),ge&&!p(Q)&&S(Q)}if(ge&&!r){let we;const Ae=function(Ee){Ee.propertyName==="height"&&(clearTimeout(we),we=setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},50))};pe.addEventListener("transitionend",Ae),setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},600)}else requestAnimationFrame(()=>{setTimeout(ee,100)})}})}C(d,!0),a||requestAnimationFrame(()=>{const T=t.querySelector(".ecom-item-group-init");T&&T.classList.remove("ecom-item-group-init")});function x(){const T=window.location.hash;if(T){const F=t.querySelector(`[data-target="${T}"]`);if(F){F.click(),F.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const K=F.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(K)}}}requestAnimationFrame(()=>{setTimeout(x,100)}),window.addEventListener("resize",()=>C(d)),window.addEventListener("hashchange",x,!1)

                    });
                    
                        document.querySelectorAll('.ecom-ow25n1xufki').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ow25n1xufki', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ow25n1xufki', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rl0x7f0xz3r"]=  window.__ectimmers["ecom-rl0x7f0xz3r"] || {};
if(!this.$el)return!1;const t=this.$el;let e=t.closest(".ecom-product-form--single");if(!e){const n=t.closest(".ecom-builder");n&&(e=n.querySelector(".ecom-product-form--single"))}if(!e)return!1;if(this.isLive){let n=e.querySelector("[name=id]");const s=(n?parseInt(n.getAttribute("ec-variants")):0)>250||e.querySelector("[data-high-variant-product]"),r=t.querySelector(".ecom-product-single__buy_it_now_btn--checkout"),a=e.dataset.product_id;if(!a)return;let l=null;const c=e.querySelector("[id^=product-json-"+a+"]");if(!c)return;try{l=JSON.parse(c.innerHTML)}catch(d){return}r&&r.addEventListener("click",function(d){d.preventDefault();let p=1;e.querySelector("[name=quantity]")&&(p=e.querySelector("[name=quantity]").value);let m=e.querySelector("select[name=id]")||e.querySelector("input[name=id]");m||console.warn("EC error: Select id or input id not found!");let _=m.value,b=null;if(s?b=l:b=l.variants.find(v=>v.id==_),!b||b.available===!1)return;window.Shopify.analytics&&Shopify.analytics.publish("ec_buy_now",{cartLine:{cost:{totalAmount:{amount:b.price*p,currencyCode:window.Shopify.currency.active}},merchandise:{id:b.id,image:b.image,price:{amount:b.price,currencyCode:window.Shopify.currency.active},product:{id:l.id,title:l.title,vendor:l.vendor},sku:b.sku,title:b.title},quantity:p}});let y=`${window.EComposer.routes.cart_url}/${_}:${p}`;if(window.location.search.includes("selling_plan")){const v=/selling_plan=(\d+)/,w=window.location.search.match(v);if(w){const S=w[1];y=`${window.EComposer.routes.cart_url}/clear?return_to=/cart/add?items[][id]=${_}%26items[][quantity]=${p}%26items[][selling_plan]=${S}%26return_to=/checkout`}}location.href=y}),l.available||(r.classList.add("ecom-disable-buy"),r.disabled=!0),n&&e.addEventListener("ecomVariantChange",function(d){let p=d.detail.variant;!p||p.available===!1?(r.classList.add("ecom-disable-buy"),r.disabled=!0):(r.classList.remove("ecom-disable-buy"),r.disabled=!1)})}const i=function(n){if(!t)return;const o=t.querySelector(".ecom-product-single__buy_it_now_btn--checkout");if(!o)return;let s=parseInt(n.settings.animation_loop_time)*1e3||6e3,r=1e3;window.__ectimmers["ecom-rl0x7f0xz3r"]["ep260in59"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},r)},s)};this.settings.animation&&i(this)

                    });
                    
                        document.querySelectorAll('.ecom-rl0x7f0xz3r').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-rl0x7f0xz3r', settings: {"animation":true},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-rl0x7f0xz3r', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-dt7pha4sj7').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-dt7pha4sj7', settings: {"animation":true},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-dt7pha4sj7', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}